import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencyTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('urgency-timer-end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    const end = Date.now() + 45 * 60 * 1000;
    sessionStorage.setItem('urgency-timer-end', end.toString());
    return 45 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-[#D4AF37] shadow-lg shadow-gold/20" data-id="element-254">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 sm:gap-4 py-3.5 px-3" data-id="element-255">
        <div className="flex items-center gap-1.5" data-id="element-256">
          <motion.span animate={{
          scale: [1, 1.2, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="text-lg sm:text-xl" data-id="element-257">
            🔥
          </motion.span>
          <span className="font-sans font-extrabold text-xs sm:text-base text-black uppercase tracking-wider" data-id="element-258">
            Oferta termina en:
          </span>
        </div>

        <div className="flex items-center gap-1" data-id="element-259">
          <motion.div animate={{
          boxShadow: ['0 0 8px rgba(212,175,55,0.3)', '0 0 20px rgba(212,175,55,0.7)', '0 0 8px rgba(212,175,55,0.3)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="bg-black rounded-md px-2.5 py-2 min-w-[40px] sm:min-w-[50px] text-center" data-id="element-260">
            <span className="font-mono font-black text-xl sm:text-3xl text-white leading-none" data-id="element-261">
              {pad(hours)}
            </span>
          </motion.div>
          <span className="font-black text-black text-xl sm:text-3xl" data-id="element-262">:</span>
          <motion.div animate={{
          boxShadow: ['0 0 8px rgba(212,175,55,0.3)', '0 0 20px rgba(212,175,55,0.7)', '0 0 8px rgba(212,175,55,0.3)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.3
        }} className="bg-black rounded-md px-2.5 py-2 min-w-[40px] sm:min-w-[50px] text-center" data-id="element-263">
            <span className="font-mono font-black text-xl sm:text-3xl text-white leading-none" data-id="element-264">
              {pad(minutes)}
            </span>
          </motion.div>
          <span className="font-black text-black text-xl sm:text-3xl" data-id="element-265">:</span>
          <motion.div animate={{
          boxShadow: ['0 0 8px rgba(212,175,55,0.3)', '0 0 20px rgba(212,175,55,0.7)', '0 0 8px rgba(212,175,55,0.3)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.6
        }} className="bg-black rounded-md px-2.5 py-2 min-w-[40px] sm:min-w-[50px] text-center" data-id="element-266">
            <motion.span key={seconds} initial={{
            opacity: 0.5,
            y: -4
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.2
          }} className="font-mono font-black text-xl sm:text-3xl text-[#D4AF37] leading-none inline-block" data-id="element-267">
              {pad(seconds)}
            </motion.span>
          </motion.div>
        </div>
      </div>
    </div>;
}